import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "./css/App.css";
import KlantenPagina from "./Pages/Klanten/KlantenPagina";
import Header from "./Components/Header";
import KlantPagina from "./Pages/Klant/KlantPagina";
import AbonnementToevoegenPagina from "./Pages/Abonnement/AbonnementToevoegenPagina";
import RenderOnRole from "./Utilities/RenderOnRole";
import RenderOnAuthenticated from "./Utilities/RenderOnAuthenticated";
import RenderOnAnonymous from "./Utilities/RenderOnAnonymous";
import LoginPage from "./Pages/LoginPage";
import DashboardKlant from "./Pages/Dashboard/DashboardKlant";
import InterfaceToevoegenPagina from "./Pages/Interface/InterfaceToevoegenPagina";
import BetalingenPagina from "./Pages/Betalingen/BetalingenPagina";
import PromptOptsPagina from "./Pages/PdfVerwerking/PromptOptsPagina";
import PromptOptPagina from "./Pages/PdfVerwerking/PromptOptPagina";
import PdfParserPagina from "./Pages/Tools/PdfParserPagina";
import Base64ConverterPagina from "./Pages/Tools/Base64ConverterPagina";
import FactuurKvkPagina from "./Pages/PdfVerwerking/FactuurKvkPagina";
import CreditorPagina from "./Pages/PdfVerwerking/CreditorPagina";
import FactuurReferentiePagina from "./Pages/PdfVerwerking/FactuurReferentiePagina";
import { ThemeProvider } from "./contexts/ThemeContext";
import "./css/header.css"
import "./css/dark-mode.css"
import PathTesterPagina from "./Pages/Tools/PathTesterPagina";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <RenderOnAnonymous>
          <LoginPage />
        </RenderOnAnonymous>
        <RenderOnAuthenticated>
          <Header />
          <RenderOnRole roles={["SD_Medewerker"]}>
            <div className="grid grid-cols-12 h-screen w-full">
              <div className="col-span-1 h-full" />
              <div className="col-span-10 h-full">
                <Switch>
                  <Route exact path="/">
                    <KlantenPagina />
                  </Route>
                  <Route path="/Klanten">
                    <KlantenPagina />
                  </Route>
                  <Route path="/Klant/:id" component={KlantPagina} />
                  <Route
                    path="/Abonnementtoevoegen"
                    component={AbonnementToevoegenPagina}
                  />
                  <Route
                    path="/Interfacetoevoegen"
                    component={InterfaceToevoegenPagina}
                  />
                  <Route path="/DashboardKlant">
                    <DashboardKlant />
                  </Route>
                  <Route path="/PromptOpt/create">
                    <PromptOptPagina />
                  </Route>
                  <Route
                    path="/PromptOpt/:id"
                    component={PromptOptPagina}
                  />
                  <Route path="/PromptOpt">
                    <PromptOptsPagina />
                  </Route>
                  <Route path="/PdfParser">
                    <PdfParserPagina />
                  </Route>
                  <Route path="/Base64Converter">
                    <Base64ConverterPagina />
                  </Route>
                  <Route path="/PathTester">
                    <PathTesterPagina />
                  </Route>
                  <Route path="/FactuurKvk/create">
                    <CreditorPagina />
                  </Route>
                  <Route
                    path="/FactuurKvk/:id"
                    component={CreditorPagina}
                  />
                  <Route path="/FactuurKvk">
                    <FactuurKvkPagina />
                  </Route>
                  <Route path="/FactuurReferentie">
                    <FactuurReferentiePagina />
                  </Route>
                  <Route path="/">
                    <KlantenPagina />
                  </Route>
                </Switch>
              </div>
              <div className="col-span-1 h-full" />
            </div>
          </RenderOnRole>
          <RenderOnRole roles={["Administrator"]}>
            <div className="grid grid-cols-12 h-screen w-full">
              <div className="col-span-1 h-full" />
              <div className="col-span-10 h-full">
                <Switch>
                  <Route exact path="/">
                    <KlantenPagina />
                  </Route>
                  <Route path="/Klanten">
                    <KlantenPagina />
                  </Route>
                  <Route path="/Klant/:id" component={KlantPagina} />
                  <Route
                    path="/Abonnementtoevoegen"
                    component={AbonnementToevoegenPagina}
                  />
                  <Route
                    path="/Interfacetoevoegen"
                    component={InterfaceToevoegenPagina}
                  />
                  <Route path="/Betalingen" component={BetalingenPagina} />
                  <Route path="/DashboardKlant">
                    <DashboardKlant />
                  </Route>
                  <Route path="/PromptOpt/create">
                    <PromptOptPagina />
                  </Route>
                  <Route
                    path="/PromptOpt/:id"
                    component={PromptOptPagina}
                  />
                  <Route path="/PromptOpt">
                    <PromptOptsPagina />
                  </Route>
                  <Route path="/PdfParser">
                    <PdfParserPagina />
                  </Route>
                  <Route path="/Base64Converter">
                    <Base64ConverterPagina />
                  </Route>
                  <Route path="/PathTester">
                    <PathTesterPagina />
                  </Route>
                  <Route path="/FactuurKvk/create">
                    <PromptOptPagina />
                  </Route>
                  <Route
                    path="/FactuurKvk/:id"
                    component={PromptOptPagina}
                  />
                  <Route path="/FactuurKvk">
                    <FactuurKvkPagina />
                  </Route>
                  <Route path="/FactuurReferentie">
                    <FactuurReferentiePagina />
                  </Route>
                  <Route path="/">
                    <KlantenPagina />
                  </Route>
                </Switch>
              </div>
              <div className="col-span-1 h-full" />
            </div>
          </RenderOnRole>
          <RenderOnRole roles={["Klant"]}>
            <div className="grid grid-cols-12 h-screen w-full">
              <div className="col-span-1" />
              <div className="col-span-10 h-full">
                <Switch>
                  <Route exact path="/">
                    <DashboardKlant />
                  </Route>
                  <Route path="/DashboardKlant">
                    <DashboardKlant />
                  </Route>
                  <Route path="/">
                    <DashboardKlant />
                  </Route>
                </Switch>
              </div>
              <div className="col-span-1" />
            </div>
          </RenderOnRole>
        </RenderOnAuthenticated>
      </Router>
    </ThemeProvider>
  );
}
export default App;
